<template>
  <div class="edit-wrapper">
    <div class="tabs">
      <span :class="{ active : active === 'editBlog' }" @click="active = 'editBlog'">Blog</span>
      <span :class="{ active : active === 'editNews' }" @click="active = 'editNews'">News</span>
    </div>
    <keep-alive>
      <component :is="getActiveComponent" />
    </keep-alive>
  </div>
</template>

<script>
import editBlog from '@/components/admin/editBlog.vue'
import editNews from '@/components/admin/editNews.vue'
export default {
  name: 'Edit',
  components: {
    editBlog,
    editNews
  },
  data () {
    return {
      active: 'editBlog'
    }
  },
  computed: {
    getActiveComponent () {
      return this.active
    }
  }
}
</script>

<style lang="scss" scoped>
.edit-wrapper {
  .tabs {
    margin-bottom: 20px;
    span {
      margin-right: 20px;
      cursor: pointer;
    }
    span:last-child {
      margin-right: 0px;
    }
    span.active {
      color: $main-color;
    }
  }
}
</style>
